/**decription: 设置permisionAssignment 高度
 * created by: chenhao
 * created time:2017-12-14 22:51:08
 */
"use strict";
angular.module("trsPermissionModule", [])
    .directive("trsPermission", ["$window", "$timeout", function($window, $timeout) {
        return {
            restrict: 'A',
            link: function(scope, iElem, iAttrs) {
                function setPermissionHeight() {
                    $timeout(function() {
                        var correctedValue = !!iAttrs["correctedValue"]?Number(iAttrs["correctedValue"]):0;
                        var height = $(window).height() - ($(".view_head").outerHeight(true) + 50 + $(".tabBtn").outerHeight(true) + 105);
                        iElem.height(height-correctedValue);
                    });
                }
                setPermissionHeight();
                $("body,.tabBtn,.view_head,.permissionAssignment .permission").resize(function() {
                    setPermissionHeight();
                });
            }
        }
    }]);